import { ILink } from '@prodelio/router/breadcrumbs/interfaces/ILink';

export abstract class Strategy {
  protected abstract transformItem(item: unknown): ILink;
}

export interface IStrategy {
  getLinks(): ILink[];
}
